module.exports = __webpack_public_path__ + "static/media/reason-flag-icon.83a48207.svg";